module.exports = __webpack_public_path__ + "media/images/press_kit/test/email/main-c11d3d97a0567ff936f16e9edb284319.png";